// extracted by mini-css-extract-plugin
module.exports = {"page-header":"e3d914","page-header-wrapper":"_25435a"};